import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: absolute;
  left: 55px;
  bottom: 34px;
`;

export const RecordDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  top: -5px;
  left: -5px;
  margin-right: 10px;
  animation: blink 1s infinite;

  @keyframes blink {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`;

export const Loading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;

  background: linear-gradient(270deg, yellow, hotpink, yellow);
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 3s ease infinite;

  @keyframes gradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export const Running = styled.div`
  display: flex;
  flex-direction: row;
  color: color;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  background-color: #000000c5;
  padding: 0 10px;
  border-radius: 10px;
  color: red;
  margin-bottom: 10px;
  margin-left: -20px;
`;
